import React from 'react';
import { motion } from 'framer-motion';

const ITProcess = ({
    title = "Our Recruitment Process",
    steps = []
}) => {
    return (
        <section className="py-24 bg-white">
            <div className="container mx-auto px-6 max-w-5xl">
                <div className="max-w-3xl mx-auto text-center mb-16">
                    <h2 className="text-3xl font-bold mb-4 syne text-[#01014C]">
                        {title}
                    </h2>
                    <p className="text-slate-500 text-sm md:text-base leading-relaxed">
                        A timeline-driven workflow customized for sourcing, testing, interviewing, and onboarding high-caliber candidates.
                    </p>
                </div>
                <div className="relative">
                    <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-blue-300 -translate-x-1/2" />
                    {steps && steps.map((step, i) => (
                        <div key={i} className={`flex items-center mb-12 w-full ${i % 2 === 0 ? 'md:flex-row-reverse' : ''}`}>
                            <div className="md:w-1/2" />
                            <div className="absolute left-4 md:left-1/2 w-8 h-8 bg-blue-600 rounded-full border-4 border-white z-10 -translate-x-1/2 flex items-center justify-center text-[10px] text-white font-bold">{i+1}</div>
                            <motion.div initial={{ opacity: 0, x: i % 2 === 0 ? -50 : 50 }} whileInView={{ opacity: 1, x: 0 }} className="md:w-1/2 pl-12 md:px-12">
                                <div className="bg-blue-50/20 border border-blue-100/50 p-6 rounded-2xl shadow-md">
                                    <h4 className="font-bold text-blue-600 uppercase  text-xs mb-2">Step 0{i+1}</h4>
                                    <h3 className="font-bold text-slate-800 mb-2 text-md!">{step.title}</h3>
                                    <p className="text-slate-500 text-sm leading-relaxed">{step.description}</p>
                                </div>
                            </motion.div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ITProcess;